"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

exports.__esModule = true;

var Node_1 = __importDefault(require("./Node"));

var ColourChisel_1 = __importDefault(require("../../ColourChisel"));

var HSL =
/** @class */
function (_super) {
  __extends(HSL, _super);

  function HSL() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  HSL.prototype.parse = function () {
    this.tokenizer.checkNextAndPop("hsl");
    this.tokenizer.checkNextAndPop("(");
    this.h = this.tokenizer.getNextAndPop();
    this.tokenizer.checkNextAndPop(",");
    this.s = this.tokenizer.getNextAndPop();
    this.tokenizer.checkNextAndPop(",");
    this.l = this.tokenizer.getNextAndPop();
    this.tokenizer.checkNextAndPop(")");
  };

  HSL.prototype.typeCheck = function () {
    var _this = this;

    [this.h, this.s, this.l].forEach(function (v) {
      if (isNaN(v)) {
        throw new Error("'hsl(" + _this.h + "," + _this.s + "," + _this.l + ")' is not a valid HSL.");
      }
    });
  };

  HSL.prototype.evaluate = function () {
    return new ColourChisel_1["default"]([parseFloat(this.h), parseFloat(this.s), parseFloat(this.l)]);
  };

  return HSL;
}(Node_1["default"]);

exports["default"] = HSL;